import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import FormComponent from "../Form/FormComponent";
import { Dialog } from "@material-ui/core";
import { withStyles, Link } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { CampaignModalConfig } from "../Campaign/CampaignConfig";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import "./campaignModal.css";
import { fetchMethod } from "../../FetchMethod";
import { saveCampaignstep, getLimitPerDay } from "../Campaign/campaignQueries";
import store from "../../Redux/Store";
// modal props must have a button title and a dialog title
const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle className={classes.root}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {},
}))(MuiDialogContent);

export default function CustomizedDialogs(props) {
  const [open, setOpen] = React.useState(
    props.showButton === false ? true : false
  );
  let [addsteps, setsteps] = useState({});
  let [maxLimits, setMaxlimit] = useState();
  let [limitsPerDay, setlimitsPerDay] = useState([]);

  const handleClickOpen = () => {
    setOpen(true);
    // store.dispatch({
    //   type: "CAMPAIGN_WORKFLOW_CLICK_TYPE",
    //   payload: "Standard",
    // });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const addcampaignModalValidation = Yup.object().shape({
  
    stepname: Yup.string()
      .ensure()
      .test("stepname", "Please select step", (value) => {
        return value != "Select";
      }),

    // limitperday: Yup.string()
    //   .matches(/^\d+$/, {
    //     message: "Digits only",
    //     excludeEmptyString: true,
    //   })
    //   .test("limit not put", "Please enter max. limit", function (value) {
    //     return (
    //       value !== undefined ||
    //       (store.getState().addModalStep.length >= 1 &&
    //         (this.parent.stepname === "SEND_THANKS_MESSAGE" ||
    //           this.parent.stepname === "SEND_MESSAGE") &&
    //         store.getState().addModalStep[0].stepname !== "SEND_MESSAGE")
    //     );
    //   })
    //   .test("is not zero", "Limit can't be zero", (value) => value != 0)
    //   .test("is not max limits", "Can't exceed max limit", function (value) {
    //     return (
    //       value <= maxLimits ||
    //       (store.getState().addModalStep.length >= 1 &&
    //         (this.parent.stepname === "SEND_THANKS_MESSAGE" ||
    //           this.parent.stepname === "SEND_MESSAGE") &&
    //         store.getState().addModalStep[0].stepname !== "SEND_MESSAGE")
    //     );
    //   }),
  //   limitperday: Yup.string()
  // .matches(/^\d+$/, {
  //   message: "Digits only",
  //   excludeEmptyString: true,
  // })
  // .test("limit not put", "Please enter max. limit", function (value) {
  //   return (
  //     value !== undefined ||
  //     (store.getState().addModalStep.length >= 1 &&
  //       (this.parent.stepname === "SEND_THANKS_MESSAGE" ||
  //         this.parent.stepname === "SEND_MESSAGE") &&
  //       store.getState().addModalStep[0].stepname !== "SEND_MESSAGE")
  //   );
  // })
  // .test("is not zero", "Limit can't be zero", (value) => value != 0)
  // .test("is not max limits", "Can't exceed max limit", function (value) {
  //   return (
  //     value <= maxLimits ||
  //     (store.getState().addModalStep.length >= 1 &&
  //       (this.parent.stepname === "SEND_THANKS_MESSAGE" ||
  //         this.parent.stepname === "SEND_MESSAGE") &&
  //       store.getState().addModalStep[0].stepname !== "SEND_MESSAGE")
  //   );
  // })
  // .test("open check", "Limit can't be zero when open = 1", function (value) {
  //   if (this.parent.open === 1 && Number(value) === 0) {
  //     return false;
  //   }
  //   return true;
  // }),
  limitperday: Yup.string()
  .matches(/^\d+$/, {
    message: "Digits only",
    excludeEmptyString: true,
  })
  .test(
    "required-when-open-or-step",
    "Limit is required",
    function (value) {
   
      // var cc=  store.getState().addModalStep.length;
      // var nn =   store.getState().campaignWorkflowClickType ;
      // var ll=  this.parent.open === 1 ;
      if (
       store.getState().campaignWorkflowClickType == "Open" 
        //  ||
        //  store.getState().addModalStep.length == 0
      ) {
        return value !== undefined && value !== "";
      }
      return true; // skip check otherwise
    }
  )
  .test("limit not put", "Please enter max. limit", function (value) {
    return (
      value !== undefined ||
      (store.getState().addModalStep.length >= 1 &&
        (this.parent.stepname === "SEND_THANKS_MESSAGE" ||
          this.parent.stepname === "SEND_MESSAGE") &&
        store.getState().addModalStep[0].stepname !== "SEND_MESSAGE")
    );
  })
  .test("is not zero", "Limit can't be zero", (value) => value != 0)
  .test("is not max limits", "Can't exceed max limit", function (value) {
      if (store.getState().campaignWorkflowClickType == "Open"  &&     value >= maxLimits ){
      return false;
    }
    return (
      value <= maxLimits ||
      (store.getState().addModalStep.length >= 1 &&
        (this.parent.stepname === "SEND_THANKS_MESSAGE" ||
          this.parent.stepname === "SEND_MESSAGE") &&
        store.getState().addModalStep[0].stepname !== "SEND_MESSAGE")
    );
  })
  .test("open check", "Limit can't be zero when open = 1", function (value) {
    if ( store.getState().campaignWorkflowClickType == "Open"  && Number(value) === 0) {
      return false;
    }  
    return true;
  }),


    daysdelay: Yup.string()
      .required("Please enter days delay")
      .matches(/^\d+$/, {
        message: "Digits only",
        excludeEmptyString: true,
      })
      .max(2, "Days delay should be less than 3 digits only"),

    message: Yup.string().when("stepname", {
      is: "SEND_MESSAGE",
      then: Yup.string()
        .required("Please enter message")

        .max(3000, "Message should be less than 3000 characters"),
    }),

    personalmessage: Yup.string().when("stepname", {
      is: "SEND_INVITE",
      then: Yup.string().max(
        250,
        "Personal message should be less than 250 characters"
      ),
    }),

    replyMessage: Yup.string().when("stepname", {
      is: "SEND_THANKS_MESSAGE",
      then: Yup.string()
        .required("Please enter thanks message")
        .max(3000, "Thanks message should be less than 3000 characters"),
    }),
  });

  useEffect(() => {
    fetchMethod(getLimitPerDay)
      .then((res) => res.json())
      .then((res) => {
        setlimitsPerDay(res.data.allSystemsettings.Systemsettings[0]);
      })
      .catch((e) => console.log(e));
  }, []);

  const datas = (data) => {
    setMaxlimit(data);
  };

  const renderModalContent = (props) => {
  
    return (
      <div className="addStepForm">
        <FormComponent
          mtitle="ADD_STEP"
          editableData={props.editableData}
          limitsPerDay={limitsPerDay}
          formConfig={CampaignModalConfig}
          modalClose={handleClose}
          statedata={addsteps}
          setLimit={datas} // function calling for max limit
          query={store.getState().isEditMode === true ? saveCampaignstep : ""}
          formValidation={addcampaignModalValidation}
          message="New Step added successfully"
          storeArray="addModalStep"
          buttonName={"Save"}
        />
      </div>
    );
  };

  return (
    <div>
      <div
        onClick={
          localStorage.getItem("role") !== "CAMPAIGNMANAGER"
            ? handleClickOpen
            : ""
        }
        // style={{
        //   cursor: "pointer",
        //   textAlign: "left",
        //   borderRadius: "10px",
        //   paddingLeft: "7px",
        //   paddingRight: "7px",
        //   border: "1px solid gray",
        //   display: "inline-block",
        // }}
        style={{ cursor: "pointer", textDecoration: "underline", marginLeft: "90%", color: "#3f51b5" }}
      >
        {/* <span
          style={{ color: "#a8a6a0", fontWeight: "bold", fontStyle: "italic" }}
        >
          Standard Campaign
        </span> */}
        {/* <br /> */}
        {/* <span style={{ color: "red", fontWeight: "bold" }}>Add Steps</span> */}
        Add Steps
      </div>

      <div>
        <Dialog aria-labelledby="customized-dialog-title" open={open}>
          <div className="campaignModal">
            <DialogTitle id="customized-dialog-title" onClose={handleClose}>
              <div className="CampaignModalTitle">Add Step</div>
            </DialogTitle>
            <DialogContent>{renderModalContent(props)}</DialogContent>
          </div>
        </Dialog>
      </div>
    </div>
  );
}
